import "react";
import { css as e, styled as t } from "styled-components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/Badge/Badge.tsx
var i = {
	default: e`
        background-color: ${({ theme: e }) => e.colors.primary};
        color: ${({ theme: e }) => e.colors.primaryForeground};
        border-color: transparent;
    `,
	secondary: e`
        background-color: ${({ theme: e }) => e.colors.secondary};
        color: ${({ theme: e }) => e.colors.secondaryForeground};
        border-color: transparent;
    `,
	destructive: e`
        background-color: ${({ theme: e }) => e.colors.destructive};
        color: ${({ theme: e }) => e.colors.destructiveForeground};
        border-color: transparent;
    `,
	outline: e`
        background-color: transparent;
        color: ${({ theme: e }) => e.colors.foreground};
        border-color: ${({ theme: e }) => e.colors.border};
    `,
	success: e`
        background-color: ${({ theme: e }) => e.colors.success};
        color: ${({ theme: e }) => e.colors.successForeground};
        border-color: transparent;
    `,
	warning: e`
        background-color: ${({ theme: e }) => e.colors.warning};
        color: ${({ theme: e }) => e.colors.warningForeground};
        border-color: transparent;
    `
}, a = (e, t) => `color-mix(in srgb, ${e} ${t}%, transparent)`, o = {
	default: e`
        background-color: ${({ theme: e }) => a(e.colors.primary, 12)};
        color: ${({ theme: e }) => e.colors.primary};
        border-color: transparent;
    `,
	secondary: i.secondary,
	destructive: e`
        background-color: ${({ theme: e }) => a(e.colors.destructive, 12)};
        color: ${({ theme: e }) => e.colors.destructive};
        border-color: transparent;
    `,
	outline: i.outline,
	success: e`
        background-color: ${({ theme: e }) => a(e.colors.success, 14)};
        color: ${({ theme: e }) => e.colors.success};
        border-color: transparent;
    `,
	warning: e`
        background-color: ${({ theme: e }) => e.colors.warningContainer};
        color: ${({ theme: e }) => e.colors.onWarningContainer};
        border-color: transparent;
    `
}, s = {
	sm: e`
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
        padding: 1px 6px;
        height: 18px;
    `,
	md: e`
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
        padding: 2px 8px;
        height: 22px;
    `
}, c = t.span`
    width: 6px;
    height: 6px;
    border-radius: ${({ theme: e }) => e.radii.full};
    background-color: currentColor;
    flex-shrink: 0;
`, l = t.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: ${({ theme: e }) => e.radii.full};
    border: 1px solid;
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    white-space: nowrap;
    line-height: 1;
    transition: background-color ${({ theme: e }) => e.transitions.fast};
    ${({ $variant: e, $appearance: t }) => t === "soft" ? o[e] : i[e]}
    ${({ $size: e }) => s[e]}
`, u = ({ children: e, variant: t = "default", size: i = "md", appearance: a = "solid", dot: o = !1, icon: s, className: u }) => /* @__PURE__ */ r(l, {
	$variant: t,
	$size: i,
	$appearance: a,
	className: u,
	children: [
		o && /* @__PURE__ */ n(c, { $variant: t }),
		s && /* @__PURE__ */ n(s, {
			size: 12,
			strokeWidth: 2.5
		}),
		e
	]
});
//#endregion
export { u as Badge };
